import * as React from "react";

function SvgIcKeys(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M8.667 7A1.179 1.179 0 117 8.667 1.179 1.179 0 018.667 7z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.04 11.293a3.714 3.714 0 116.215-1.664l-.15.558 1.158 1.157-.96.96a.75.75 0 001.06 1.06l.96-.96.606.606-.96.96a.75.75 0 101.061 1.06l.96-.96.606.607-.96.96a.75.75 0 001.061 1.06l.952-.951a2 2 0 01-.144 2.668L17 18.92l-6.813-6.813-.558.149a3.712 3.712 0 01-3.589-.962zM4.626 4.626a5.714 5.714 0 004.937 9.684l6.023 6.023a2 2 0 002.828 0l.505-.505a4 4 0 000-5.657L14.31 9.563a5.714 5.714 0 00-9.684-4.936z"
        fill="currentColor"
      />
    </svg>
  );
}

export default SvgIcKeys;
